import { Typography } from '@mui/material';
import { FlexContainer } from '../../ContentContainers/FlexContainer';

interface DocketMobileCardSubHeaderProps {
  topic: string;
  date?: string;
  time?: string;
}

export const DocketMobileCardSubHeader = ({
  topic,
  date,
  time,
}: DocketMobileCardSubHeaderProps) => {
  let subheader = topic;

  if (date) {
    subheader += `${topic?.length ? ' • ' : ''}${date}`;
  }
  if (time) {
    subheader += ` • ${time}`;
  }

  return (
    <FlexContainer
      direction="row"
      gap={0}
      height="fit-content"
      width="100%"
      sx={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      }}
    >
      <Typography
        component="div"
        variant="bodySmall"
        sx={{
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        }}
      >
        {subheader}
      </Typography>
    </FlexContainer>
  );
};
